<template>
    <div class="article-page">
        <header class="top-nav">
            <button type="button" class="back-btn" @click="$router.back()">
                <van-icon name="arrow-left" />
            </button>
            <div class="nav-title">{{ data.title || $t('index.article') }}</div>
        </header>

        <main class="page-content">
            <section class="article-card">
                <div v-if="data.title" class="article-title">{{ data.title }}</div>
                <div class="article-content contract_box" v-html="data.content"></div>
            </section>
        </main>
    </div>
</template>

<script>
import Vue from "vue";
import { Icon } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Icon);

export default {
    name: "aritcle",
    data() {
        return {
            data: {},
            appOriginalStyles: null,
            bodyOriginalBackground: "",
        };
    },
    created() {
        this.$parent.footer("user", false);
    },
    mounted() {
        this.applyFullScreenLayout();
        this.start();
    },
    beforeDestroy() {
        this.restoreFullScreenLayout();
    },
    methods: {
        applyFullScreenLayout() {
            const app = document.getElementById("app");
            if (!app) {
                return;
            }
            this.appOriginalStyles = {
                maxWidth: app.style.maxWidth,
                width: app.style.width,
                margin: app.style.margin,
                backgroundColor: app.style.backgroundColor,
                paddingBottom: app.style.paddingBottom,
            };
            this.bodyOriginalBackground = document.body.style.background;
            app.style.maxWidth = "100%";
            app.style.width = "100%";
            app.style.margin = "0";
            app.style.backgroundColor = "#000000";
            app.style.paddingBottom = "0";
            document.body.style.background = "#000000";
        },
        restoreFullScreenLayout() {
            const app = document.getElementById("app");
            if (app && this.appOriginalStyles) {
                app.style.maxWidth = this.appOriginalStyles.maxWidth || "";
                app.style.width = this.appOriginalStyles.width || "";
                app.style.margin = this.appOriginalStyles.margin || "";
                app.style.backgroundColor = this.appOriginalStyles.backgroundColor || "";
                app.style.paddingBottom = this.appOriginalStyles.paddingBottom || "";
            }
            document.body.style.background = this.bodyOriginalBackground || "";
        },
        start() {
            Fetch("/index/article_detail", {
                id: this.$router.history.current.params.code,
            }).then((res) => {
                this.data = res.data || {};
            });
        },
    },
};
</script>

<style lang="less" scoped>
.article-page {
    min-height: 100vh;
    background:
        radial-gradient(circle at top right, rgba(33, 86, 255, 0.2), transparent 28%),
        linear-gradient(180deg, #020612 0%, #000000 52%, #000000 100%);
    color: #fff;
}

.top-nav {
    position: sticky;
    top: 0;
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    padding: 0 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(0, 0, 0, 0.88);
    backdrop-filter: blur(12px);
}

.back-btn {
    position: absolute;
    left: 16px;
    top: 50%;
    width: 28px;
    height: 28px;
    margin-top: -14px;
    border: 0;
    background: transparent;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.back-btn .van-icon {
    font-size: 22px;
}

.nav-title {
    max-width: 64%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 18px;
    font-weight: 700;
}

.page-content {
    width: 100%;
    max-width: 430px;
    margin: 0 auto;
    padding: 24px 14px 30px;
    box-sizing: border-box;
}

.article-card {
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 18px;
    background: rgba(6, 18, 52, 0.62);
    box-shadow: inset 0 0 0 1px rgba(45, 91, 255, 0.08);
    backdrop-filter: blur(12px);
}

.article-card {
    min-height: calc(100vh - 120px);
    padding: 20px 18px;
}

.article-title {
    margin-bottom: 18px;
    padding-bottom: 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    color: #fff;
    font-size: 20px;
    font-weight: 800;
    line-height: 1.5;
}

.article-content {
    color: rgba(255, 255, 255, 0.82);
    font-size: 14px;
    line-height: 1.9;
    word-break: break-word;
}

:deep(.article-content img),
:deep(.article-content image) {
    max-width: 100% !important;
    height: auto !important;
    border-radius: 10px;
    margin: 10px 0;
}

:deep(.article-content p),
:deep(.article-content div),
:deep(.article-content span),
:deep(.article-content li),
:deep(.article-content td),
:deep(.article-content th),
:deep(.article-content strong),
:deep(.article-content em),
:deep(.article-content h1),
:deep(.article-content h2),
:deep(.article-content h3),
:deep(.article-content h4),
:deep(.article-content h5),
:deep(.article-content h6) {
    color: rgba(255, 255, 255, 0.82) !important;
}

:deep(.article-content a) {
    color: #5d82ff !important;
    text-decoration: underline;
}

:deep(.article-content p) {
    margin: 0 0 12px;
}

:deep(.article-content ul),
:deep(.article-content ol) {
    padding-left: 18px;
    margin: 0 0 12px;
}

:deep(.article-content table) {
    width: 100% !important;
    border-collapse: collapse;
    margin: 12px 0;
}

:deep(.article-content table td),
:deep(.article-content table th) {
    border: 1px solid rgba(255, 255, 255, 0.1);
    padding: 8px;
}
</style>
